export default "__VITE_ASSET__BCUu1F$y__"